import api from '@/apis'
import { API_PREFIX } from '@/constants'
import type { CallbackSuccessResponse, NaverpaySuccessCallbackBody } from '@/payment/types'

/**
 * 네이버페이 단건결제 returnUrl 콜백.
 *
 * 네이버 SDK의 returnUrl로 돌아온 뒤 query에서 resultCode/paymentId 받아 호출.
 */
export const apiPostCallbackNaverpaySuccess = async (
  paymentId: number,
  body: NaverpaySuccessCallbackBody
): Promise<CallbackSuccessResponse> => {
  return api.post(`${API_PREFIX.PAYMENT}/product-payments/callback/naverpay/success/${paymentId}`, body)
}
